import React from 'react';
import { Star } from 'lucide-react';
interface TestimonialProps {
  name: string;
  role: string;
  location: string;
  text: string;
  imageInitials: string;
}
export function TestimonialCard({
  name,
  role,
  location,
  text,
  imageInitials
}: TestimonialProps) {
  return <div className="bg-white p-6 rounded-2xl shadow-lg border border-gray-100 flex flex-col h-full" data-id="element-252">
      <div className="flex items-center gap-1 mb-4" data-id="element-253">
        {[1, 2, 3, 4, 5].map(star => <Star key={star} className="w-5 h-5 fill-yellow-400 text-yellow-400" data-id="element-254" />)}
      </div>

      <p className="text-gray-700 italic mb-6 flex-grow" data-id="element-255">"{text}"</p>

      <div className="flex items-center gap-3 mt-auto" data-id="element-256">
        <div className="w-10 h-10 rounded-full bg-[#0D9488] flex items-center justify-center text-white font-bold text-sm" data-id="element-257">
          {imageInitials}
        </div>
        <div data-id="element-258">
          <h4 className="font-bold text-gray-900 text-sm" data-id="element-259">{name}</h4>
          <p className="text-xs text-gray-500" data-id="element-260">{role}</p>
          <p className="text-xs text-gray-400" data-id="element-261">{location}</p>
        </div>
      </div>
    </div>;
}